import React, { useRef, useState } from "react";
import {
  MapContainer,
  TileLayer,
  WMSTileLayer,
  Popup,
  useMapEvent,
  LayersControl,
  Polygon,
  Circle,
} from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";
import proj4 from "proj4";
import TableModal from "./TableModal";
import { Card, Modal, Button } from "react-bootstrap";

const MapView = () => {
  
  const [responseUrl, setResponseUrl] = useState();
  const [bboxCoord, setbboxCoord] = useState();
  const [latitude, setLat] = useState();
  const [longitude, setLng] = useState();
  const mapRef = useRef();
  proj4.defs("EPSG:25830", "+proj=utm +zone=30 +ellps=GRS80 +units=m +no_defs");
  proj4.defs("EPSG:4326", "+proj=longlat +datum=WGS84 +no_defs");

  // Maneja el clic en el mapa
  const handleMapClick = async (e) => {
    const { lat, lng } = e.latlng;
    setLat(lat)
    setLng(lng)
    // Obtener la referencia al mapa
    const map = mapRef.current;

    // Construir la URL para GetFeatureInfo
    const wmsUrl = "http://192.168.1.132:8080/geoserver/cite/wms";

    const coords25830 = proj4("EPSG:4326", "EPSG:25830", [lng, lat]);
    const bbox2 = `${coords25830[0] - 20},${coords25830[1] - 20},${
      coords25830[0] + 20
    },${coords25830[1] + 20}`;
    const setbb = proj4("EPSG:25830", "EPSG:4326", [
      coords25830[0] + 20,
      coords25830[1] + 20,
    ]);
    const setbb2 = proj4("EPSG:25830", "EPSG:4326", [
      coords25830[0] - 20,
      coords25830[1] - 20,
    ]);

    const latLngs = [
      [setbb2[1], setbb2[0]], // Suroeste
      [setbb2[1], setbb[0]], // Sureste
      [setbb[1], setbb[0]], // Noreste
      [setbb[1], setbb2[0]], // Noroeste
      [setbb2[1], setbb2[0]], // Cerrar el polígono
    ];
    setbboxCoord(latLngs);
    const encodedBbox = encodeURIComponent(bbox2);

    const bounds = map.getBounds();
    const bbox = `${bounds.getWest()},${bounds.getSouth()},${bounds.getEast()},${bounds.getNorth()}`;
    const url = `https://parcelario-solponiente.com/geoserver/cite/wms?SERVICE=WMS&VERSION=1.1.1&REQUEST=GetFeatureInfo&FORMAT=image/png&TRANSPARENT=true&QUERY_LAYERS=cite:Grupo de capas Solponiente&STYLES=&LAYERS=cite:Grupo de capas Solponiente&exceptions=application/vnd.ogc.se_inimage&INFO_FORMAT=text/html&FEATURE_COUNT=50&X=50&Y=50&SRS=EPSG:25830&WIDTH=101&HEIGHT=101&BBOX=${encodedBbox}`;

    try {
      const response = await fetch(url);
      if (response.ok) {
        const htmlData = await response.text();
        setResponseUrl(htmlData);
      } else {
        console.error("Error fetching feature info:", response.statusText);
      }
    } catch (error) {
      console.error("Error fetching feature info:", error);
      alert("Error al obtener la información.");
    }
  };

  // Componente para manejar eventos de clic
  const MapClickHandler = () => {
    useMapEvent("click", handleMapClick);
    return null;
  };
  return (
    <div style={{ flex: 1 }}>
          <MapContainer
            center={[36.734558, -2.864418]}
            zoom={14}
            style={{ minHeight: "100%", width: "100%", cursor: "auto" }}
            ref={mapRef}
            scrollWheelZoom={false}
          >
            <LayersControl collapsed={false} position="bottomleft">
              <LayersControl.BaseLayer checked name="Mapa">
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  //attribution="&copy; <a href='https://www.openstreetmap.org/copyright'>OpenStreetMap</a> contributors"
                />
              </LayersControl.BaseLayer>
              <LayersControl.BaseLayer name="Satélite">
                <TileLayer url="https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}" />
              </LayersControl.BaseLayer>
              {/* Capa WMS desde GeoServer */}
              <LayersControl.Overlay checked name="Parcelario">
                <WMSTileLayer
                  url="https://parcelario-solponiente.com/geoserver/cite/wms"
                  layers="cite:Parcelario de riego" // Nombre de la capa en GeoServer
                  format="image/png" // Formato de la imagen
                  transparent={true} // Fondo transparente
                  version="1.1.0" // Versión del servicio WMS
                  styles="" // Estilos, si hay (dejar vacío si no se necesita)
                />
              </LayersControl.Overlay>
              <LayersControl.Overlay name="Parcelas tuberias">
                <WMSTileLayer
                  url="https://parcelario-solponiente.com/geoserver/cite/wms"
                  layers="cite:Parcelas influencia tuberias Sol Poniente" // Nombre de la capa en GeoServer
                  format="image/png" // Formato de la imagen
                  transparent={true} // Fondo transparente
                  version="1.1.0" // Versión del servicio WMS
                  styles="" // Estilos, si hay (dejar vacío si no se necesita)
                />
              </LayersControl.Overlay>
              <LayersControl.Overlay name="Hidrantes ">
                <WMSTileLayer
                  url="https://parcelario-solponiente.com/geoserver/cite/wms"
                  layers="cite:Hidrantes Sol Poniente"
                  format="image/png"
                  transparent={true}
                  version="1.1.0"
                  styles=""
                />
              </LayersControl.Overlay>
              <LayersControl.Overlay name="Tuberías ">
                <WMSTileLayer
                  url="https://parcelario-solponiente.com/geoserver/cite/wms"
                  layers="cite:Tuberias Sol Poniente"
                  format="image/png"
                  transparent={true}
                  version="1.1.0"
                  styles=""
                />
              </LayersControl.Overlay>
               <LayersControl.Overlay name="NDVI">
                <WMSTileLayer
                  url="https://parcelario-solponiente.com/geoserver/cite/wms"
                  layers="cite:ndvi" // Nombre de la capa en GeoServer
                  format="image/png" // Formato de la imagen
                  transparent={true} // Fondo transparente
                  version="1.1.0" // Versión del servicio WMS
                  styles="ndvi_ramp" // Estilos, si hay (dejar vacío si no se necesita)
                  opacity={0.7}
                />
              </LayersControl.Overlay>
            </LayersControl>
            <MapClickHandler></MapClickHandler>
            {latitude && longitude? 
            <Circle
              center={[latitude, longitude]}
              radius={10}
              color="#162d50"
              fillColor="#162d50"
              fillOpacity={0.6}
            />
            : "" }
            {/* {bboxCoord ? (
              <Polygon
                positions={bboxCoord}
                color="blue"
                fillColor="lightblue"
                fillOpacity={0.5}
              />
            ) : (
              ""
            )} */}
          </MapContainer>

      {responseUrl ? <TableModal response={responseUrl} latlng={[latitude,longitude]}></TableModal> : ""}
      {/* <Card className="mt-2 mb-3 mx-1">
        <div className="mt-4 mb-1 mx-1">
          <p
            style={{
              color: "#333333",
              fontSize: "14px",
            }}
          >
            Selecciona una parcela para ver más información.
          </p>
        </div>
      </Card> */}
    </div>
  );
};

export default MapView;
